import React from 'react'

const PermissaoRoutes = [
    {
        path: '/permissao',
        exact: true,
        component: React.lazy(() => import('./cadastros/lista/Table')),
    },
    {
        path: '/permissao/novo',
        exact: true,
        component: React.lazy(() => import('./cadastros/form/Form')),
    }
]

export default PermissaoRoutes
